import React, { useRef } from 'react';
import styled, { keyframes } from 'styled-components';
import { useOnScreen } from '../../hooks/useOnScreen';
import { ColorContextProvider } from '../../src/providers/ColorContext';
const bounceIn = (isVisible) => keyframes `
  0% {
    opacity: 0;
    transform: scale(0.3);
  }
  50% {
    opacity: ${isVisible ? 1 : 0};
    transform: scale(1.05);
  }
  70% {
    transform: scale(0.9);
  }
  100% {
    transform: scale(1);
  }
`;
const StyledBox = styled.div `
  animation: ${props => bounceIn(props.isVisible)} 0.25s ease 1;
  background: ${props => props.theme.White};
  border-radius: 35%;
  display: grid;
  width: 100%;
  height: 100%;
  padding: 10%;
`;
export const BounceBox = ({ children }) => {
    const ref = useRef(null);
    const isInViewport = useOnScreen({
        ref: ref,
        root: null,
        rootMargin: '0px',
        threshold: 0.01,
    });
    return (React.createElement(ColorContextProvider, { backgroundColor: "#fff" },
        React.createElement(StyledBox, { isVisible: isInViewport, ref: ref }, children)));
};
